import { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";

const useGetSelectedPublication = ({ defaultUpfCourseId, isCurriculumOrCourseChanged = false, publications }) => {
  let selectedPublication = useSelector(state => state.UPFAssignReducer.selectedPublication, shallowEqual);
  const [publication, setPublication] = useState(selectedPublication);

  useEffect(() => {
    if (isCurriculumOrCourseChanged) {
		setPublication(selectedPublication)
	} else {
		for(const key in publications) {
			if(publications[key].courses.includes(defaultUpfCourseId)) {
				setPublication({
					value: publications[key].id,
					label: publications[key].name
				});
				break;
			}
      	}	
	}
  },[publications, defaultUpfCourseId, isCurriculumOrCourseChanged, selectedPublication?.value])

  return { selectedPublication: publication };
}

export default useGetSelectedPublication;


// WEBPACK FOOTER //
// ./components/course-filters/hooks/use-get-selected-publication.js